import {Client} from '@liquor/client'

export class BFFClient extends Client {
  getEnvInfo() {
    return this.get('/env')
  }
  getCurrentUserInfo() {
    return this.get('/account/current')
  }
  getActivityDetail(id) {
    return this.get(`/activity_be/c/activity/activities/${id}`, {}, {underscoreRequestData: false, camelizeResponseData: false})
  }
  registrationActivity({activityId, sceneId}, data) {
    return this.post(`/activity_be/c/activity/registration?activity_id=${activityId}&scene_id=${sceneId}`, data, {underscoreRequestData: false, camelizeResponseData: false})
  }
}
